import {
  AfterViewInit,
  Component,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import { CognitoService } from "../../services/cognito/cognito.service";
import { UserClaims } from "../../models/user.claims";
import { GlobalSupplierService } from "../../services/global-supplier/global-supplier.service";

declare const $: any;

// Menu Items
export const ROUTES: RouteInfo[] = [
  {
    path: '/pages/dashboard',
    title: 'Dashboard',
    type: 'link',
    icontype: 'fa-solid fa-home',
    visible: true,
  },
  {
    path: '/pages',
    title: 'Network',
    type: 'sub',
    icontype: 'fa-solid fa-server',
    collapse: 'mikrotik',
    visible: true,
    children: [
      {
        path: 'research',
        title: 'Ricerca',
        ab: 'SC',
        icontype: 'fa-solid fa-search',
        visible: true,
      },
      {
        path: 'systeminfo',
        title: 'Informazioni Generali',
        ab: 'IG',
        icontype: 'fa-solid fa-info',
        visible: true,
      },
      {
        path: 'interfacelist',
        title: 'Lista Interfacce',
        icontype: 'fa-solid fa-ethernet',
        ab: 'LI',
        visible: true,
      },
      {
        path: 'monitoring',
        title: 'Monitoraggio',
        icontype: 'fab fa-watchman-monitoring',
        ab: 'MO',
        visible: true,
      },
      {
        path: 'radius',
        title: 'RADIUS',
        icontype: 'fab fa-diagram-project',
        ab: 'RD',
        visible: true,
      },
    ],
  },
  {
    path: '/pages',
    title: 'Amministrazione',
    type: 'sub',
    icontype: 'fa-solid fa-building-columns',
    collapse: 'amministrazione',
    visible: true,
    children: [
      {
        path: 'chip-cards-invoices',
        title: 'Fatturazione Carte Chip',
        icontype: 'fa-solid fa-building-columns',
        ab: 'FCC',
        visible: true,
        data: { roles: ["Amministratori", "Sviluppo"] },
      }
    ]
  },
  {
    path: '/pages',
    title: 'Assistenza',
    type: 'sub',
    icontype: 'fa-solid fa-headset',
    collapse: 'assistenza',
    visible: true,
    children: [
      {
        path: 'jiraissueslist',
        title: 'Jira Issue',
        icontype: 'fa-solid fa-mail-bulk',
        ab: 'J',
        visible: true,
      },
      {
        path: 'maillogs',
        title: 'Mail log',
        icontype: 'fa-solid fa-mail-bulk',
        ab: 'ML',
        visible: true,
      },
    ],
  },
  {
    path: '/pages',
    title: 'Utenti',
    type: 'sub',
    icontype: 'fa-solid fa-user',
    collapse: 'utenze',
    visible: true,
    children: [
      {
        path: 'users',
        title: 'Gestione Utenti',
        ab: 'GU',
        icontype: 'fa-solid fa-users',
        visible: true,
      },
      {
        path: 'partners',
        title: 'Gestione Partner',
        ab: 'GP',
        icontype: 'fa-solid fa-users',
        visible: true,
      },
    ],
  },
  {
    path: '/pages',
    title: 'Overview',
    type: 'sub',
    icontype: 'fa-solid fa-chart-line',
    collapse: 'overview',
    visible: true,
    children: [
      {
        //path: 'configuration',
        title: 'Configurazioni',
        ab: 'CFG',
        type: 'children-sub',
        icontype: 'fa-solid fa-gear',
        data: { roles: ["Assistenza", "Amministratori", "Sviluppo"] },
        visible: true,
        children: [
          {
            path: 'suppliers',
            title: 'RETISTI',
            ab: 'RT',
            icontype: 'fa-solid fa-table',
            visible: true,
          },
          {
            path: 'pricedevices',
            title: 'Prezzario',
            ab: 'PZ',
            icontype: 'fa-solid fa-table',
            visible: true,
          },
          {
            path: 'companies',
            title: 'Compagnie',
            ab: 'CM',
            icontype: 'fa-solid fa-building',
            visible: true,
          },
          {
            path: 'fuelstation-level-price',
            title: 'Livello prezzi',
            ab: 'LP',
            icontype: 'fa-solid fa-hand-holding-dollar',
            visible: true,
          },
          {
            path: 'products-configuration',
            title: 'Prodotti',
            ab: 'PD',
            icontype: 'fa-solid fa-barcode',
            visible: true,
          },
          {
            path: 'tanks-configuration',
            title: 'Serbatoi',
            ab: 'SE',
            icontype: 'fa-solid fa-table',
            visible: true,
          },
          {
            path: 'totalizers-dispensers-configuration',
            title: 'Totalizzatori',
            ab: 'ET',
            icontype: 'fa-solid fa-table',
            visible: true,
            data: {
              roles: ['Amministratori', 'Sviluppo', 'Assistenza']
            }
          },
          {
            path: 'dc-versions',
            title: 'Versioni DC',
            ab: 'DC',
            icontype: 'fa-solid fa-table',
            visible: true,
            data: {
              roles: ['Amministratori', 'Sviluppo', 'Assistenza']
            }
          },
          {
            path: 'fuelstations-registry-configuration',
            title: 'Impianti',
            ab: 'IM',
            icontype: 'fa-solid fa-table',
            visible: true,
            data: {
              roles: ['Amministratori', 'Sviluppo', 'Assistenza']
            }
          }
        ]
      },
      {
        //path: 'configuration',
        title: 'Gestione e analisi',
        ab: 'GA',
        type: 'children-sub',
        icontype: 'fa-solid fa-chart-pie',
        data: { roles: ["Assistenza", "Amministratori", "Sviluppo"] },
        visible: true,
        children: [
          {
            path: 'datacollectionv1',
            title: 'Data collection',
            ab: 'DC',
            icontype: 'fa-solid fa-table',
            visible: false,
          },
          {
            path: 'datacollection',
            title: 'Raccolta Dati',
            ab: 'DCV2',
            icontype: 'fas fa-table',
            visible: true,
          },
          {
            path: 'supplies',
            title: 'Erogazioni',
            ab: 'ER',
            icontype: 'fa-solid fa-table',
            visible: true,
          },
          {
            path: 'oilcharges',
            title: 'Corrispettivi',
            ab: 'CO',
            icontype: 'fa-solid fa-table',
            visible: true,
          },
          {
            path: 'telematic-register',
            title: 'Registro Telematico',
            ab: 'RT',
            icontype: 'fa-solid fa-table',
            visible: true,
          },
          {
            path: 'iut-outcome',
            title: 'Esito IUT',
            ab: 'EIUT',
            icontype: 'fa-solid fa-table',
            visible: true,
          },
          {
            path: 'mise',
            title: 'MISE',
            ab: 'MISE',
            icontype: 'fa-solid fa-table',
            visible: true,
          },
          {
            path: 'adm',
            title: 'ADM',
            ab: 'ADM',
            icontype: 'fa-solid fa-table',
            visible: true,
          },
          {
            path: 'totalizers',
            title: 'TOTALIZZATORI',
            ab: 'TZ',
            icontype: 'fa-solid fa-table',
            visible: true,
          },
        ],
      },
    ]
  },
  {
    path: '/pages',
    title: 'Selfnet',
    type: 'sub',
    icontype: 'fa-solid fa-credit-card',
    collapse: 'selfnet',
    visible: true,
    children: [
      {
        //path: 'configuration',
        title: 'Configurazioni',
        ab: 'CFG',
        type: 'children-sub',
        icontype: 'fa-solid fa-gear',
        data: { roles: ["Assistenza", "Amministratori", "Sviluppo"] },
        visible: true,
        children: [
          {
            path: 'vendors',
            title: 'Codici Esterni',
            ab: 'CE',
            icontype: 'fa-solid fa-cash-register',
            data: { roles: ["Assistenza", "Amministratori", "Sviluppo"] },
            visible: true,
          },
          {
            path: 'terminals',
            title: 'Terminali',
            ab: 'TER',
            icontype: 'fa-solid fa-cash-register',
            data: { roles: ["Assistenza", "Amministratori", "Sviluppo"] },
            visible: true,
          },
          {
            path: 'pos',
            title: 'Configurazione POS',
            ab: 'POS',
            icontype: 'fa-solid fa-cash-register',
            data: { roles: ["Assistenza", "Amministratori", "Sviluppo"] },
            visible: true,
          },
        ]
      },
      {
        //path: 'managment-analyses',
        title: 'Gestione e Analisi',
        ab: 'GA',
        type: 'children-sub',
        icontype: 'fa-solid fa-chart-pie',
        visible: true,
        children: [
          {
            path: "analysis-terminals",
            title: "Terminali",
            ab: "TL",
            icontype: "fa-solid fa-rectangle-terminal",
            data: { roles: ["Assistenza", "Amministratori", "Sviluppo"] },
            visible: true,
          },
          {
            path: 'erogazioniPendenti',
            title: 'Erogazioni pendenti',
            ab: 'EGPD',
            icontype: 'fa-solid fa-database',
            data: { roles: ["Assistenza", "Amministratori", "Sviluppo"] },
            visible: true,
          },
          {
            path: 'pending-fuelcoupons',
            title: 'Buoni pendenti',
            ab: 'BUOPD',
            icontype: 'fa-solid fa-database',
            data: { roles: ["Assistenza", "Amministratori", "Sviluppo"] },
            visible: true,
          },
          {
            path: 'analisidati',
            title: 'Analisi dati',
            ab: 'AN',
            icontype: 'fa-solid fa-database',
            data: { roles: ["Assistenza", "Amministratori", "Sviluppo"] },
            visible: true,
          },
          {
            path: 'invoices',
            title: 'Fatture',
            ab: 'FA',
            icontype: 'fa-solid fa-cash-register',
            data: { roles: ["Assistenza", "Amministratori", "Sviluppo"] },
            visible: true,
          },
          {
            path: 'invoice-details',
            title: 'Dettaglio Fatture',
            ab: 'DF',
            icontype: 'fa-solid fa-cash-register',
            data: { roles: ["Assistenza", "Amministratori", "Sviluppo"] },
            visible: true,
          },
          {
            path: 'customersduplicate',
            title: 'Clienti duplicati',
            ab: 'CLD',
            icontype: 'fa-solid fa-user-circle',
            data: { roles: ["Assistenza", "Amministratori", "Sviluppo"] },
            visible: true,
          },
          {
            path: 'history',
            title: 'Storico',
            ab: 'ST',
            icontype: 'fa-solid fa-table',
            data: { roles: ["Assistenza", "Amministratori", "Sviluppo"] },
            visible: true,
          },
          {
            path: 'invoice-go',
            title: 'I&GO lite',
            ab: 'I&GO',
            icontype: 'fa-solid fa-table',
            data: { roles: ["Assistenza", "Amministratori", "Sviluppo"] },
            visible: false,
          },
          {
            path: "card-tracks",
            title: "Creazione Tracciati",
            ab: "CT",
            icontype: "fa-solid fa-table",
            data: { roles: ["Amministratori", "Sviluppo"] },
            visible: true,
          },
        ],
      },
    ],
  },
  {
    path: '/pages',
    title: 'Flotte',
    type: 'sub',
    icontype: 'fa-solid fa-bus',
    collapse: 'fleet',
    visible: true,
    children: [
      {
        path: 'configurationkey',
        title: 'attivazione chiave',
        ab: 'activefleet',
        icontype: 'fa-solid fa-bus',
        visible: true,
      },
    ],
  },
  ,
  {
    path: '/pages',
    title: 'IFSF',
    type: 'sub',
    icontype: 'fa-solid fa-gears',
    collapse: 'ifsf',
    data: { roles: ["Amministratori", "Sviluppo"] },
    visible: true,
    children: [
      {
        path: 'terminal-encode',
        title: 'Codifica',
        ab: 'TC',
        icontype: 'fa-solid fa-bus',
        visible: true,
      },
      {
        path: 'terminal-decode',
        title: 'Decodifica',
        ab: 'TD',
        icontype: 'fa-solid fa-bus',
        visible: true,
      },
    ],
  },
];

@Component({
  selector: "app-sidebar-cmp",
  templateUrl: "sidebar.component.html",
  styleUrls: ["sidebar.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class SidebarComponent implements OnInit, AfterViewInit {
  public menuItems: any[];
  public lastItem = "string";
  private user: UserClaims;

  constructor(
    private cognitoService: CognitoService,
    private globalSupplierService: GlobalSupplierService
  ) { }

  ngOnInit() {
    this.menuItems = ROUTES.filter((menuItem) => menuItem);
    this.cognitoService.user.subscribe((user: UserClaims) => {
      if (this.user != user) this.applyUserRoles(user, this.menuItems);
      if (this.user == null) this.user = user;
    });
    this.applyUserRoles(this.user, this.menuItems);
  }

  ngAfterViewInit(): void {
    this.updatePS(localStorage.getItem("lastItemSidebar"));
  }

  isMac(): boolean {
    let bool = false;
    if (
      navigator.platform.toUpperCase().indexOf("MAC") >= 0 ||
      navigator.platform.toUpperCase().indexOf("IPAD") >= 0
    ) {
      bool = true;
    }
    return bool;
  }

  /**
   * Apply roles from routes to data structure of sidebar.
   *
   * @param menuItems this is a list of sidebar data's.
   */
  applyUserRoles(user: UserClaims, menuItems: Array<RouteInfo>) {
    menuItems.forEach((menuItem) => {
      let nrItem: number = 0;

      menuItem.visible = menuItem.data?.roles
        ? menuItem.data.roles.some((menuItemData) => this.hasRole(user.groups, menuItemData, menuItem.visible))
        : menuItem.visible;

      if (menuItem.visible) {
        if (menuItem.children != null) {
          menuItem.children.forEach((children) => {

            children.visible = children.data?.roles
              ? children.data.roles.some((childrenData) => this.hasRole(user.groups, childrenData, children.visible))
              : children.visible;

            if (children.children != null) {

              children.children.forEach((subChildren) => {
                subChildren.visible = subChildren.data?.roles
                  ? subChildren.data.roles.some((subChildrenData) => this.hasRole(user.groups, subChildrenData, subChildren.visible))
                  : subChildren.visible;
              })
              nrItem++;
            } else {
              children.visible = children.data?.roles
                ? children.data.roles.some((childrenData) => this.hasRole(user.groups, childrenData, children.visible))
                : children.visible;
              nrItem++;
            }
          });
        }
      }

      menuItem.visible = nrItem > 0;
    });
  }

  /**
   * Return true when the item is disabled by the global supplier.
   * A group is disabled when all its visible items are disabled.
   *
   * @param item menu item
   */
  isNetworkDisabled(item: RouteInfo | ChildrenItems): boolean {
    if (item.children != null && item.children.length > 0) {
      const visibleChildren = item.children.filter((child) => child.visible !== false);
      return visibleChildren.length > 0 && visibleChildren.every((child) => this.isNetworkDisabled(child));
    }

    const path = item.path?.split("/").pop();
    return !this.globalSupplierService.isPageEnabled(path);
  }

  private hasRole(userGroups: string[] | null, role: string, visible?: boolean): boolean {
    // If `visible` is false, return false without checking `userGroups`
    if (visible === false) {
      return false;
    }

    // If `visible` is true, check if the role exists in `userGroups`
    if (visible === true) {
      return userGroups?.indexOf(role) >= 0 || false;
    }

    // If `visible` is undefined, check if the role exists in `userGroups`
    return userGroups?.indexOf(role) >= 0 || false;

  }

  public openDoc() {
    window.open(
      "https://icadsistemi.atlassian.net/wiki/spaces/MI/pages/149422115/fa-solidtlane",
      "_blank"
    );
  }

  updatePS(item: string): void {
    // get for local storage
    this.lastItem = localStorage.getItem("lastItemSidebar");
    if (this.lastItem && this.lastItem == item) {
      $("#" + this.lastItem).addClass("show");
      localStorage.setItem("lastItemSidebar", null);
    } else {
      $("#" + this.lastItem).addClass("show");
      $("li:not(.active) > a.nav-link").attr("aria-expanded", false);
      $(".sidebar-wrapper .show").removeClass("show");
      $("div.collapse .show").removeClass("show");
      $("a.nav-link").addClass("collapsed");
      $("li.active > a.nav-link").attr("aria-expanded", true);
      $("li:not(.active) > a.nav-link").attr("aria-expanded", false);
      localStorage.setItem("lastItemSidebar", item);
    }
  }
}

//Metadata
export interface RouteInfo {
  path: string;
  title: string;
  type: string;
  icontype: string;
  collapse?: string;
  visible: boolean;
  data?: Data;
  children?: ChildrenItems[];
}

export declare type Data = {
  [key: string | symbol]: any;
};

export interface ChildrenItems {
  path?: string;
  title: string;
  icontype: string;
  ab: string;
  type?: string;
  data?: Data;
  visible: boolean;
  children?: ChildrenItems[];
}
